import { render, staticRenderFns } from "./skelton.vue?vue&type=template&id=549a6df1&scoped=true&"
import script from "./skelton.vue?vue&type=script&lang=js&"
export * from "./skelton.vue?vue&type=script&lang=js&"
import style0 from "./skelton.vue?vue&type=style&index=0&id=549a6df1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549a6df1",
  null
  
)

export default component.exports